var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressBar19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 45.96 202.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#9efc86;}.cls-3{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_36);}.cls-4{mix-blend-mode:screen;fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_6);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_36",
    x1: -182.06,
    y1: -919.6,
    x2: -182.06,
    y2: -881.22,
    gradientTransform: "translate(925.8 -84.22) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#41d163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#30b95a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#239d5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#117966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#0b6b68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#107568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#1e8f66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#34b964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#41d163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_6",
    x1: -91.64,
    y1: -911.65,
    x2: -303.16,
    y2: -911.65,
    gradientTransform: "translate(925.8 -84.22) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1c472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.69,4.34H31c3.91,0,7.09.88,7.09,2V189.36c0,1.09-3.18,2-7.09,2H12.69c-3.92,0-7.08-.88-7.08-2V6.31C5.61,5.22,8.77,4.34,12.69,4.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.82,4.34H29.9c3.43,0,6.22.88,6.22,2V189.36c0,1.09-2.79,2-6.22,2H13.82c-3.44,0-6.21-.88-6.21-2V6.31C7.61,5.22,10.38,4.34,13.82,4.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.78,5.22h.76C17,5.22,19,5.81,19,6.54V189.36c0,.85-2.34,1.53-5.22,1.53h0c-2.46,0-4.47-.59-4.47-1.31V6.54C9.31,5.81,11.32,5.22,13.78,5.22Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressBar19);
export default __webpack_public_path__ + "static/media/Progress Bar-19.e5b92c0b52f16e35ebe76760ad4e5966.svg";
export { ForwardRef as ReactComponent };